<template>
  <van-list class="list">
    <!-- 小卡片 -->
    <van-cell v-for="(item, index) in list" :key="index">
      <div class="card" @click="onClick(item)">
        <img :src="item.image" />
        <span>{{ item.title }}</span>
      </div>
    </van-cell>
  </van-list>
</template>

<script>
export default {
  name: "SmallCard",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    list() {
      return this.data;
    },
  },

  methods: {
    onClick(item) {
      this.$router.push({
        path: "/detail",
        query: {
          id: item.id,
          type: item.type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list{
  box-sizing: border-box;
  height: calc(100% - 96px);
  max-width: 800px;
  margin: auto;
  overflow: auto;
}

.card {
  overflow: hidden;
  border-radius: 8px;
  box-sizing: border-box;
  margin: 5px 16px;
  box-shadow: 0 2px 5px 0 rgb(50 50 50 / 15%);

  .card-img {
    height: 200px;
  }

  .swiper {
    width: 100%;
    height: 190px;
    overflow: hidden;
  }

  span {
    text-align: right;
    position: absolute;
    bottom: 10px;
    color: #fff;
    right: 20px;
    border-bottom: 3px #bc4853 solid;
    padding: 0 5px;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
